import {
  CollectionName,
  CollectionVisibility,
} from "../registry/collection-registry"
import type { CollectionCreateSchema } from "../types/typesense"

export const languageSchema: CollectionCreateSchema = {
  name: CollectionName.Language,
  enable_nested_fields: true,
  fields: [
    {
      name: "id",
      type: "string",
      sort: true,
      infix: true,
    },
    {
      name: "language_code",
      type: "string",
      sort: true,
      infix: true,
    },
    {
      name: "language_name",
      type: "string",
      sort: true,
      infix: true,
      optional: true,
    },
    {
      name: "right_to_left",
      type: "bool",
      sort: true,
      infix: true,
      optional: true,
    },
    {
      name: "active",
      type: "bool",
      sort: true,
      infix: true,
    },
    {
      name: "updated_at",
      type: "int64",
      sort: true,
      infix: true,
    },
    {
      name: "updated_by",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
  ],
  visibility: CollectionVisibility.Public,
}
